const resume = {
  "basics": {
    "name": "郭小洋",
    "label": "Web前端工程师",
    "picture": "https://avatars2.githubusercontent.com/u/8994590?s=460&v=4",
    "email": "guoxiaoang0925@gmail.com",
    "phone": "155XXXX3279",
    "website": "guoxiaoyang.xyz",
    "summary": [
      "热爱编程，学习能力强", 
      "获得FCC前端及数据可视化证书，并完成多个后端项目", 
      "熟悉Web应用开发技术及流程，能够独立完成从UI设计到后端服务搭建",
      "目前关注于React技术栈，希望成为一个独当一面的全栈开发者，并寻求某一细分方向深耕",
      "较好的书写与口语表达能力"
    ],
    "location": {
      "address": "北京市海淀区东王庄小区" ,
      "postalCode": "100190",
      "city": "北京市",
      "countryCode": "中国",
      "region": "海淀区"
    },
    "profiles": [
      {
        "network": "github",
        "username": "GuoXiaoyang",
        "url": "https://github.com/GuoXiaoyang"
      },
      {
        "network": "instagram",
        "username": "GuoXiaoyang",
        "url": "https://www.instagram.com/mrguo_missshaw"
      },
      {
        "network": "envelope",
        "username": "GuoXiaoyang",
        "url": "mailto:guoxiaoyang0925@gmail.com"
      },
      {
        "network": "home",
        "username": "GuoXiaoyang",
        "url": "http://blog.guoxiaoyang.xyz"
      },
      {
        "network": "linkedin-square",
        "username": "GuoXiaoyang",
        "url": "http://www.linkedin.com/in/guoxiaoyang/"
      },
      {
        "network": "medium",
        "username": "GuoXiaoyang",
        "url": "https://medium.com/@guoxiaoyang0925"
      },
      {
        "network": "free-code-camp",
        "username": "GuoXiaoyang",
        "url": "https://www.freecodecamp.org/guoxiaoyang"
      }
    ]
  },
  "work": [
    {
      "company": "个人开发者",
      "position": "前端开发工程师",
      "website": "http://blog.guoxiaoyang.xyz",
      "startDate": "2017-07-01",
      "endDate": "Present",
      "summary": "北京市",
      "highlights": [
        "获得FreeCodeCampus 前端及数据可视化证书",
        "独立开发基于React技术栈的多个Web应用，并针对移动设备进行自适应布局", 
        "熟悉Web应用前后端开发流程，上线基于MERN(MongoDB、Express、React、Node.js)技术栈的Web应用，实现基于ip或者认证用户的投票系统"
      ]
    },
    {
      "company": "华为北研所",
      "position": "图像算法工程师",
      "website": "http://huawei.com",
      "startDate": "2016-06-15",
      "endDate": "2017-04-23",
      "summary": "北京市",
      "highlights": [
        "参与华为高端手机HiXXX项目中camera成像算法调试，优化图像噪声特性，前后调试10余版本，关闭15+问题单",
        "参与华为手机camera成像多个预研算法评测及分析方案制定及实施，输出方案及报告20+份", 
        "带领小团队完成华为中端手机 HiXXX项目图像质量调试及验证，负责团队任务分解、目标制定、进展汇报及最终报告输出"
      ]
    },
    {
      "company": "实习图像算法工程师",
      "position": "通用电气医疗集团",
      "website": "http://blog.guoxiaoyang.xyz",
      "startDate": "2015-05-01",
      "endDate": "2015-10-01",
      "summary": "北京市",
      "highlights": [
        "C语言实现基于HS算法和TV-L1算法的三维CT图像的光流运动估计",
        "通过OpenCL并行计算提高算法效率，算法运行时间比Matlab版快10倍", 
        "利用ITK软件对图像进行分割计算"
      ]
    }
  ],
  "volunteer": [
    {
      "organization": "<ORGANIZATION_NAME>",
      "position": "<POSITION>",
      "website": "<WEBSITE>",
      "startDate": "2016-06-15",
      "endDate": "2017-04-23",
      "summary": "<SUMMARY>",
      "highlights": ["<HIGHTLIGHT_1>", "<HIGHTLIGHT_2>", "<HIGHTLIGHT_3>"]
    }
  ],
  "education": [
    {
      "institution": "中国科学院大学",
      "area": "信号与信息处理",
      "studyType": "硕士",
      "startDate": "2013-09-01",
      "endDate": "2016-06-01",
      "gpa": "3.2",
      "summary": "硕士",
      "courses": ["信号处理", "数字图像处理", "随机过程"]
    },
    {
      "institution": "武汉大学",
      "area": "电子信息科学与技术",
      "studyType": "学士",
      "startDate": "2009-09-01",
      "endDate": "2013-06-01",
      "gpa": "3.2",
      "summary": "学士",
      "courses": ["计算机网络", "c语言设计", "高等数学"]
    }
  ],
  "awards": [
    {
      "title": "<AWARD_TITLE>",
      "date": "<DATE>",
      "awarder": "<AWARDER>",
      "summary": "<SUMMARY>"
    }
  ],
  "projects": [
    {
      "name": "Wiki搜索",
      "publisher": "郭小洋",
      "category": "Web",
      "releaseDate": "2017-07-31",
      "website": "https://guoxiaoyang.github.io/WikipediaViewer/",
      "summary": "利用Wiki API实现的搜索应用",
      "image": {
        "modal": "./images/WikipediaViewer.png",
        "thumb": "./images/WikipediaViewer.png"
      },
      "keywords": ["Angular", "API","Wiki"]
    },
    {
      "name": "计算器",
      "publisher": "郭小洋",
      "category": "Web",
      "releaseDate": "2017-08-11",
      "website": "https://guoxiaoyang.github.io/JavaScript_Calculator/",
      "summary": "基于React的计算器",
      "image": {
        "modal": "./images/Calculator.png",
        "thumb": "./images/Calculator.png"
      },
      "keywords": ["React", "Calculator"]
    },
    {
      "name": "Simon游戏",
      "publisher": "郭小洋",
      "category": "Web",
      "releaseDate": "2017-08-20",
      "website": "https://guoxiaoyang.github.io/Simon-Game/",
      "summary": "基于React的Simon游戏",
      "image": {
        "modal": "./images/SimonGame.png",
        "thumb": "./images/SimonGame.png"
      },
      "keywords": ["React", "Game"]
    },
    {
      "name": "番茄时钟",
      "publisher": "郭小洋",
      "category": "Web",
      "releaseDate": "2017-09-08",
      "website": "https://guoxiaoyang.github.io/typescript-react-pomodoro/",
      "summary": "基于React的可自定义工作与休息时间的番茄时钟",
      "image": {
        "modal": "./images/PomodoroClock.png",
        "thumb": "./images/PomodoroClock.png"
      },
      "keywords": ["React", "Pomodoro"]
    },
    {
      "name": "生命游戏",
      "publisher": "郭小洋",
      "category": "Web",
      "releaseDate": "2017-09-15",
      "website": "https://guoxiaoyang.github.io/game-of-life/",
      "summary": "基于React的可自定义参数的生命游戏",
      "image": {
        "modal": "./images/GameOfLife.gif",
        "thumb": "./images/GameOfLife.png"
      },
      "keywords": ["React", "Game"]
    },
    {
      "name": "地下城游戏",
      "publisher": "郭小洋",
      "category": "Web",
      "releaseDate": "2017-09-22",
      "website": "https://guoxiaoyang.github.io/DungeonCrawlerGame/",
      "summary": "基于React的可升级打怪的地下城游戏",
      "image": {
        "modal": "./images/CrawlerGame.gif",
        "thumb": "./images/CrawlerGame.png"
      },
      "keywords": ["React", "Game"]
    },
    {
      "name": "数据可视化",
      "publisher": "郭小洋",
      "category": "Web",
      "releaseDate": "2017-09-30",
      "website": "https://guoxiaoyang.github.io/DataVisualizationProjects/",
      "summary": "基于React与D3.js的数据可视化",
      "image": {
        "modal": "./images/DataVisualization.png",
        "thumb": "./images/DataVisualization.png"
      },
      "keywords": ["React", "D3","Data Visualization"]
    },
    {
      "name": "VotingApp",
      "publisher": "郭小洋",
      "category": "Web",
      "releaseDate": "2017-10-15",
      "website": "http://voting.guoxiaoyang.xyz",
      "summary": "基于React、Node、Express、MongoDB的投票App，用户可以注册创建删除自己的投票，也可以基于IP或者认证用户进行投票，投票结果用饼图进行可视化，每个用户或者IP对同一题不可重复投票",
      "image": {
        "modal": "./images/VotingApp.png",
        "thumb": "./images/VotingApp.png"
      },
      "keywords": ["React", "Node", "Voting"]
    }
  ],
  "skills": [
    {
      "title": "编程语言",
      "description": [
        "熟悉JavaScript/HTML/CSS，Python", 
        "熟悉React/Redux及相关技术栈", 
        "熟悉Node.js后端开发",
        "目前专注于基于React-Node的全栈开发"
      ],
      "skillDetails": [
        {
          "name": "JavaScript",
          "level": "80",
          "keywords": ["<KEYWORD_1>", "<KEYWORD_2>", "<KEYWORD_3>"]
        },
        {
          "name": "Python",
          "level": "60",
          "keywords": ["<KEYWORD_1>", "<KEYWORD_2>", "<KEYWORD_3>"]
        },
        {
          "name": "Matlab",
          "level": "80",
          "keywords": ["<KEYWORD_1>", "<KEYWORD_2>", "<KEYWORD_3>"]
        },
        {
          "name": "C++",
          "level": "60",
          "keywords": ["<KEYWORD_1>", "<KEYWORD_2>", "<KEYWORD_3>"]
        }
      ]
    },
    {
      "title": "数据库系统",
      "description": [
        "熟悉非关系型数据库MongoDB"
      ],
      "skillDetails": [
        {
          "name": "MongoDB",
          "level": "70",
          "keywords": ["<KEYWORD_1>", "<KEYWORD_2>", "<KEYWORD_3>"]
        }
      ]
    },
    {
      "title": "设计技能",
      "description": [
        "熟悉PS/AI使用，了解UI设计及与前端协作"
      ],
      "skillDetails": [
        {
          "name": "PhotoShop",
          "level": "70",
          "keywords": ["<KEYWORD_1>", "<KEYWORD_2>", "<KEYWORD_3>"]
        },
        {
          "name": "Illustrator",
          "level": "70",
          "keywords": ["<KEYWORD_1>", "<KEYWORD_2>", "<KEYWORD_3>"]
        }
      ]
    }
  ],
  "languages": [
    {
      "name": "<LANGUAGE_NAME>",
      "level": "<LANGUAGE_LEVEL>"
    }
  ],
  "interests": [
    {
      "name": "<INTEREST_NAME>",
      "keywords": ["<KEYWORD_1>", "<KEYWORD_2>", "<KEYWORD_3>"]
    }
  ],
  "references": [
    {
      "name": "自我评价",
      "position": "Web前端工程师",
      "company": "个人开发者",
      "reference": "回顾过去，总结经验，展望未来"
    },
    {
      "name": "自我评价",
      "position": "Web前端工程师",
      "company": "个人开发者",
      "reference": "拥有自己的生活而不仅仅是活着"
    },
    {
      "name": "自我评价",
      "position": "Web前端工程师",
      "company": "个人开发者",
      "reference": "如果什么是努力解决不了的，那就加倍努力"
    }
  ]
};

export default resume;



// WEBPACK FOOTER //
// ./src/template/resume.zh_CN.js